import { ReportingShellControllerBaseConfig } from '../../../base';
import { ChatLayoutController } from './chatLayoutInterface';
import { ChatLayoutViewProps } from './chatLayoutProps';
import { ChatLayoutAggregate } from './chatLayoutModel';

export function createChatLayoutController(
    config: ReportingShellControllerBaseConfig
): ChatLayoutController {
    return {
        useProps(context, item, props): Omit<ChatLayoutViewProps, 'children'> {
            return {
                title: item.thread?.title ?? 'New chat',
                close: {
                    button: {
                        onClick() {
                            props.overlay.disclosure.onClose();
                        },
                    },
                },
                new: {
                    button: {
                        onClick() {
                            return props.thread.onCreate();
                        },
                    },
                },
                error: {
                    hash: props.error.hash,
                },
            };
        },
    };
}
